import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  List, 
  Plus, 
  BarChart3 
} from 'lucide-react';

const Navigation = () => {
  const location = useLocation();
  
  const navItems = [
    {
      path: '/dashboard',
      icon: Home,
      label: 'ホーム'
    },
    {
      path: '/transactions',
      icon: List,
      label: '履歴'
    },
    {
      path: '/add',
      icon: Plus,
      label: '追加'
    },
    {
      path: '/statistics',
      icon: BarChart3,
      label: '統計'
    }
  ];

  return (
    <nav className="bottom-nav">
      <div className="nav-menu">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon className="nav-icon" size={24} />
              <span className="nav-label">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;